import { useMemo } from "react";
import apiInstance from "../../helpers/apiInstance";
import { useApp } from "../../contexts/AppContext";

function useIncidents() {
  const { organizationId, pageId } = useApp();

  const basePath = useMemo(() => {
    return `${organizationId}/page/${pageId}/incident`;
  }, [organizationId, pageId]);

  const basePath1 = useMemo(() => {
    return `${organizationId}/page/${pageId}/maintenance`;
  }, [organizationId, pageId]);

  return {
    getIncidents: (payload) =>
      apiInstance.post(basePath + "/get-incidents", payload),
    getOpenMaintenances: (payload) =>
      apiInstance.post(
        basePath + "/get-open-incidents-and-maintenances",
        payload
      ),
    getMaintenance: (maintenanceId) =>
      apiInstance.get(`${basePath1}/${maintenanceId}`),
    getIncidentStatusTypes: (payload) =>
      apiInstance.get(basePath + "/status-types", payload),
    createIncident: (payload) => apiInstance.post(basePath, payload),
    getIncident: (incidentId) => apiInstance.get(`${basePath}/${incidentId}`),
    updateIncident: (payload) =>
      apiInstance.post(basePath + "/incident", payload),
    BackfillIncident: (payload) =>
      apiInstance.post(basePath + "/backfill", payload),
    updateBackfillIncident: (payload) =>
      apiInstance.post(basePath + "/updatebackfill", payload),
    deleteIncident: (payload) =>
      apiInstance.post(basePath + "/deleteIncident", payload),
  };
}

export default useIncidents;
